module.exports = __webpack_public_path__ + "img/sld_mfm_invs_4_dark.f42e0a80.svg";